import { INSPECTION_ITEM_TYPE } from '@/_legacy/constants';
import ItemWithSubItems from '@/_legacy/views/Analytics/Checklist/Items/ItemWithSubItems';
import Question from '@/_legacy/views/Analytics/Checklist/Items/Question';
import { h, defineComponent } from 'vue';

export default defineComponent({
  name: 'item',
  props: ['item', 'questions', 'response-sets', 'has-multiple-pages', 'questions-to-fetch'],
  setup(props) {
    return function render() {
      function getItem(type) {
        switch (type) {
          case INSPECTION_ITEM_TYPE.FORM:
          case INSPECTION_ITEM_TYPE.PAGE:
          case INSPECTION_ITEM_TYPE.SECTION:
          case INSPECTION_ITEM_TYPE.CONDITIONAL:
            return ItemWithSubItems;
          case INSPECTION_ITEM_TYPE.QUESTION:
            return Question;
          default:
            return null;
        }
      }

      return h('div', [
        h(getItem(props.item.type), {
          props,
        }),
      ]);
    };
  },
});
